<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="incotermForm" v-model="validIncotermForm" @submit.prevent>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="requestData.name"
                      :label="`${$t('GENERAL.LABELS.NAME')} *`"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.name || []"
                      @change="clearValidationError('name')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="requestData.code"
                      :label="`${$t('INCOTERMS.CODE')} *`"
                      :rules="[validations.required()]"
                      :error-messages="validationErrors.code || []"
                      @change="clearValidationError('code')"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-checkbox
                      v-model="requestData.include_transport"
                      :label="$t('INCOTERMS.INCLUDE_TRANSPORT')"
                      :error-messages="validationErrors.include_transport || []"
                      @change="clearValidationError('include_transport')"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">
                {{ $t("GENERAL.LABELS.BACK_BUTTON") }}
              </v-btn>
              <v-btn color="success" @click="store">
                {{ actionText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import validations from "@/views/partials/form/Validations.vue";
import { SHOW_SNACK } from "@/store/snack.module";
import userStateService from "@/common/userState.service.js";
import {
  GET_INCOTERM,
  STORE_INCOTERM,
  UPDATE_INCOTERM,
} from "@/store/incoterms.module";

export default {
  name: "EditIncoterm",
  data() {
    return {
      validations,
      tab: "tab-1",
      isProcessing: false,
      validIncotermForm: false,
      validationErrors: {},
      title: "",
      actionText: this.$t("GENERAL.LABELS.CREATE_BUTTON"),
      requestData: {
        name: "",
        code: "",
        include_transport: false,
      },
    };
  },
  computed: {
    isEditMode() {
      return Boolean(this.$route.params.id);
    },
  },
  mounted() {
    this.title = this.$t("INCOTERMS.CREATE");
    this.loadIncoterm();
  },
  methods: {
    getErrorMessage(error) {
      if (error && error.errors && typeof error.errors === "object") {
        const firstErrorField = Object.keys(error.errors)[0];
        const firstErrorList = error.errors[firstErrorField];

        if (Array.isArray(firstErrorList) && firstErrorList.length) {
          return firstErrorList[0];
        }
      }

      if (error && error.message) {
        return error.message;
      }

      return this.$t("GENERAL.UNEXPECTED_ERROR");
    },
    setValidationErrors(error) {
      this.validationErrors = (error && error.errors) || {};
    },
    clearValidationError(field) {
      if (!this.validationErrors[field]) {
        return;
      }

      this.$delete(this.validationErrors, field);
    },
    loadIncoterm() {
      if (!this.$route.params.id) {
        return;
      }

      this.title = this.$t("INCOTERMS.EDIT");
      this.actionText = this.$t("GENERAL.LABELS.EDIT_BUTTON");
      this.isProcessing = true;

      this.$store
        .dispatch(GET_INCOTERM, this.$route.params.id)
        .then((response) => {
          this.requestData = {
            name: response.name || "",
            code: response.code || "",
            include_transport: !!response.include_transport,
          };
        })
        .catch((error) => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
          this.back();
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    back() {
      this.$router.push({ name: "incoterms" });
    },
    store() {
      this.$refs.incotermForm.validate();

      if (!this.validIncotermForm) {
        return;
      }

      this.validationErrors = {};

      const action = this.isEditMode ? UPDATE_INCOTERM : STORE_INCOTERM;
      const payload = {
        name: this.requestData.name,
        code: this.requestData.code,
        include_transport: this.requestData.include_transport,
      };

      if (this.isEditMode) {
        payload.id = this.$route.params.id;
      }

      this.isProcessing = true;

      this.$store
        .dispatch(action, payload)
        .then((response) => {
          const blinkId = response?.id || this.$route.params.id;

          if (blinkId) {
            userStateService.setState(
              "table-state.incoterms-table.blinkRowItemKey",
              blinkId
            );
          }

          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.SUCCESS_MESSAGE"),
          });
          this.$router.push({ name: "incoterms" });
        })
        .catch((error) => {
          this.setValidationErrors(error);
          this.$store.dispatch(SHOW_SNACK, {
            message: this.getErrorMessage(error),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
